/** @module Auth0PostLoginHandlerHelpCenter */
/* eslint-disable import/extensions */
import Auth0UtilsBrowser from '../../../../utils/auth0-utils-browser.mjs';
import Auth0PostLoginHandlerBase from '../auth0-post-login-handler-base.mst.mjs';
import Auth0TokenStorageHelper from '../auth0-token-storage-helper.mjs';

class Auth0PostLoginHandlerHelpCenter extends Auth0PostLoginHandlerBase {
  _shouldHandleSync = (loginData) => {
    console.log(`Auth0PostLoginHandlerHelpCenter.shouldRun() => ${!!loginData.appState.shouldUseZendeskAuth}`);
    return !!loginData.appState.shouldUseZendeskAuth;
  };

  /**
   * @inheritdoc
   */
  async shouldHandle(loginData) {
    return Promise.resolve(this._shouldHandleSync(loginData));
  }

  /**
   * @inheritdoc
   */
  async run(loginData) {
    console.log('Auth0PostLoginHandlerHelpCenter.run()...');

    // Store tokens in the default locations (legacy _lat and _latv3 cookies)
    if (loginData.tokens) {
      Auth0TokenStorageHelper.storeTokensDefault(loginData.tokens);
    }

    this._redirectToThroatpunchZendeskSSO(loginData);
  }

  /*
  To work around restrictions with
    - auth0
      - Can't have more than one callback url for auth0 (Check me on this)
    - zendesk
      - Similar as above
      - CORS
  We use the existing v2 node proxy endpoint which will generate a JWT and a url to be redirected to for authentication via zendesk

  I think eventually for shipstation (maybe not ship engine) we should be able to use the webv3api endpoint for authenticating with zendesk
  This would decouple things from TP
  */
  _redirectToThroatpunchZendeskSSO = (userData) => {
    if (!userData.user) {
      return;
    }
    const returnTo = userData.appState.redirectOverride;
    const partitionHost = Auth0UtilsBrowser.getUserClaim('partition_host', userData.user);

    // make sure to hit the legacy ss-node zendesk endpoint
    const legacyPartitionHost = this._getV2RedirectForZendeskLookup(partitionHost);

    window.location.href = `https://${legacyPartitionHost}/sso/zendesk/login?return_to=${returnTo}`;
  };

  _getV2RedirectForZendeskLookup = (partitionHost) => {
    const parts = partitionHost.split('.');
    parts[0] = parts[0].replace(/^ship/i, 'ss');
    return parts.join('.');
  };
}

export default Auth0PostLoginHandlerHelpCenter;
